import { useQuery } from 'react-query';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchSearchCustomers } from 'src/services/napi/customers/fetchSearchCustomers';
import { useNotification } from '../../../../providers/notificationsProvider';

const searchCustomers = async (searchItem: string) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;
  if (!searchItem || searchItem === undefined) return;

  const data = await fetchSearchCustomers(currentProject._id, searchItem);
  return data?.data;
};

export const useSearchCustomersQuery = (customerId: string, searchItem: string) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.CUSTOMERS_SEARCH, customerId], () => searchCustomers(searchItem), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Cant find users with this name', severity: 'warning' });
    }
  });
};
